import {
  CountdownDialogCancelButton,
  CountdownDialogContent,
  CountdownDialogFooter,
  CountdownDialogHeader,
  CountdownDialogLayout,
  CountdownDialogTitle,
} from "@Components/game/career";
import CareerLeagueChangeDialog from "@Components/game/career/career-league-change-dialog";
import CareerStatus from "@Components/game/career/career-status";
import CareerTargets from "@Components/game/career/career-targets";
import { BybBackground } from "@Components/game/common";
import BybVrDialog from "@Components/game/common/dialog/byb-vr-dialog";
import SessionResultsLoadingOverlay from "@Components/game/common/session-results-loading-overlay";
import Countdown from "@Components/game/countdown";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { CareerProvider, useCareerContext } from "@Context/game/career/career-context";
import useI18n from "@i18n";
import { Container, Grid, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CAREER_BACKGROUND_URL = "https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-career-full.jpg";

const CareerContent = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { showCountdown, showPage, showCareerContent, onCountdownComplete, setShowCountdown, isCompletingSession } = useCareerContext();

  if (!showPage) return null;

  return (
    <ContainerWrapper id="CAREER" fullHeight sx={{ overflow: "hidden", position: "relative" }}>
      <BybBackground imageUrl={CAREER_BACKGROUND_URL} />

      <Container maxWidth="xl">
        <Grid container>
          {showCareerContent && (
            <Stack width="100%" spacing={6} paddingTop={theme.spacing(15)} paddingX={theme.spacing(1.5)}>
              <CareerStatus />
              <CareerTargets />
            </Stack>
          )}
        </Grid>

        <BybVrDialog name="career-countdown" open={showCountdown} onClose={() => setShowCountdown(false)}>
          <CountdownDialogLayout>
            <CountdownDialogHeader>
              <CountdownDialogTitle>{i18n("career.get-ready")}</CountdownDialogTitle>
            </CountdownDialogHeader>

            <CountdownDialogContent>
              <Countdown onComplete={onCountdownComplete} />
            </CountdownDialogContent>

            <CountdownDialogFooter>
              <CountdownDialogCancelButton color="tertiary" onClick={() => setShowCountdown(false)}>
                {i18n("cancel")}
              </CountdownDialogCancelButton>
            </CountdownDialogFooter>
          </CountdownDialogLayout>
        </BybVrDialog>

        <CareerLeagueChangeDialog />
      </Container>

      <SessionResultsLoadingOverlay open={isCompletingSession} />
    </ContainerWrapper>
  );
};

const Career = () => (
  <CareerProvider>
    <CareerContent />
  </CareerProvider>
);

export default Career;
